import { fetchAuthSession } from "aws-amplify/auth";

const AUDIT_APIS_ENDPOINT = process.env.AWS_AUDIT_APIS_ENDPOINT;

async function authHeaders() {
  const session = await fetchAuthSession();
  return { Authorization: session.tokens.idToken.toString() };
}

async function request(method, path, data) {
  const res = await fetch(`${AUDIT_APIS_ENDPOINT}${path}`, {
    method,
    headers: { "Content-Type": "application/json", ...(await authHeaders()) },
    body: data != null ? JSON.stringify(data) : undefined
  });
  if (!res.ok) {
    throw new Error(`${method} ${path} failed: ${res.status}`);
  }
  const text = await res.text();
  return text ? JSON.parse(text) : undefined;
}

const apiGet = path => request("GET", path);
const apiPost = (path, data) => request("POST", path, data);
const apiPut = (path, data) => request("PUT", path, data);
const apiDel = path => request("DELETE", path);

export { apiGet, apiPost, apiPut, apiDel };
